import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import "./allSubscriptionsModal.css";
import { KeyboardArrowDown } from "@material-ui/icons";
import { createUserSubscription } from "../../services/user.services";
import { getAllSubscriptionsType } from "../../services/subscriptions.services";

const initialState = {
  userId: "",
  // isExpired: '',
  subscriptionType: "",
  startTime: "",
  timesAllowed: 0,
};

export default function AllSubscriptionsModal({
  data,
  setSubTypeData,
  subscriptionModal,
}) {
  const [initialStateForm, setInitialStateForm] = useState(initialState);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleFormChange = (name, value) => {
    setInitialStateForm((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  useEffect(() => {
    const fnt = async () => {
      try {
        const response = await getAllSubscriptionsType(
          JSON.parse(sessionStorage.getItem("myData"))
        );
        console.log("subscription list successfull =====>>>", response.data);
        setSubTypeData(response.data);
        // setSubscriptionModal(false);
      } catch (error) {
        console.log("errorrrrrrr in all subscription list !!!!! EEROR", error);
      }
    };
    fnt();
  }, []);

  const handleSelectSubsType = (val) => {
    // console.log('valueeeeeeee userrrrr =>>>>> ', val);
    setSubTypeData(val);
    handleFormChange("subscriptionType", val._id);
    // console.log('lllllllllll SUB TYPEEEEE ==>', subTypedata);
  };

  return (
    <React.Fragment>
      <Button onClick={handleOpen}>
        <KeyboardArrowDown name="chevron-down" style={{ fontSize: 30 }} />
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box className="muiAllSubModalStyle">
          <div className="allSubModalMain">
            {data &&
              data.length > 0 &&
              data.map((val, ind) => {
                return (
                  <button
                    className="allSubModalOptions"
                    onClick={() => {
                      setSubTypeData(val);
                      handleClose();
                    }}
                  >
                    <text key={ind} className="allSubModalLabel">
                      {val.subscriptionName === "Free trial(Clock stats)"
                        ? "Free Trial"
                        : val.subscriptionName === "Free trial(Clock only)"
                        ? "Free Trial"
                        : val.subscriptionName === "times allowed(stats)"
                        ? "Usage Times"
                        : val.subscriptionName === "times allowed(only)"
                        ? "Usage Times"
                        : val.subscriptionName}{" "}
                      (
                      {val.type === "clock with stats"
                        ? "stats clock"
                        : "only clock"}
                      )
                    </text>
                  </button>
                );
              })}
          </div>
        </Box>
      </Modal>
    </React.Fragment>
  );
}
